// List offer requests
export async function fetchOfferRequests(requestFn, params = {}) {
  const { limit, offset, advisor_email, user_email } = params;
  const finalParams = {
    ...(typeof limit === 'number' ? { limit } : {}),
    ...(typeof offset === 'number' ? { offset } : {}),
    ...(advisor_email ? { advisor_email } : {}),
    ...(user_email ? { user_email } : {}),
  };

  return requestFn({ url: 'admin/offer-request', params: finalParams });
}

// Offer request detail
export async function fetchOfferRequestDetail(requestFn, id) {
  return requestFn({ url: `admin/offer-request/${encodeURIComponent(id)}` });
}

// Update status of an offer request.
export async function updateOfferRequestStatus(postFn, id, status) {
  const cleanStatus = String(status || '').trim();
  if (!cleanStatus) throw new Error('Status cannot be empty.');
  return postFn({
    url: `admin/offer-request/${encodeURIComponent(id)}/status`,
    data: { status: cleanStatus },
    headers: { 'Content-Type': 'application/json' },
  });
}
